import { createSlice } from '@reduxjs/toolkit'

export const CreateProjectContentTypeSlice = createSlice(
  {
  name: 'content_type_for_project_creation',
  initialState: {
    value: "",
  },
  reducers: {
    updateContentType: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateContentType } = CreateProjectContentTypeSlice.actions

export default CreateProjectContentTypeSlice.reducer